import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormModule } from 'src/app/shared/modulos/form.module';
import { I_InitBtnsSuperioresOv } from '../../../domain/interfaces/ov-mantenimiento.interface';
import { ComercialRepository } from 'src/app/repositorio/comercial.repository';
import { UtilService } from 'src/app/services/util.service';
import { parametrosRepository } from 'src/app/parametros/servicio/parametros.repository';
import { ParametrosNSDTO } from 'src/app/parametros/domain/parametros.response';
import { MantenimientoOVOperacionesLogica } from 'src/app/comercial/orden-venta/presentacion/mantenimiento-orden-venta/mantenimiento-orden-venta-validacion-op';
import { itemsTnsEventosOvRequest, ListaDetCotizacionOVEventoRequest } from 'src/app/comercial/orden-venta/domain/request/comercial-orden-venta-request';
import { TooltipModule } from 'primeng/tooltip';


@Component({
  selector: 'app-ov-funciones-botones-superior',
  standalone: true,
  imports: [
    CommonModule,
    FormModule,
    TooltipModule,
  ],
  templateUrl: './ov-funciones-botones-superior.component.html',
  styleUrl: './ov-funciones-botones-superior.component.css'
})
export class OvFuncionesBotonesSuperiorComponent {

  @Input({ required: true }) oRow!: I_InitBtnsSuperioresOv;
  btn_documentada: boolean = true;
  btn_prefacturar: boolean = true;
  PARA_OVDOCUMENTADA: ParametrosNSDTO[] = [];
  @Output() onDocumentadaFn = new EventEmitter<(data: any) => void>();
  @Output() onDocEnd = new EventEmitter<void>();
  ListaMods: any[] = [];
  private _listados: any;
  @Input() set listados(value: any) {
    if (value) {
      this._listados = value;
      this.procesarListados();
    }
  }
  get listados(): any {
    return this._listados;
  }

  constructor(
    private readonly util: UtilService
    , private readonly ordenventaService: ComercialRepository
    , private readonly paramRepository: parametrosRepository
  ) {

  }

  ngOnInit(): void {
    if (this.oRow) {
      this.cargarDatosIniciales();
    }
    this.listarärametros();
  }

  private procesarListados() {
    this.ListaMods = this.listados.ListaMods || [];
  }

  listarärametros() {
    this.paramRepository.getTblParametros({ para_clave: "OVDOCUMENTADA" }).subscribe(res => {
      if (res.datos.status === 200) {
        this.PARA_OVDOCUMENTADA = res.datos.result;
      }
    })
  }

  cargarDatosIniciales() {
    const estado = this.oRow.cons_codest;
    switch (estado) {
      case "004": // concluida
        this.btn_documentada = false;
        break;
      case "006": // documentada
        this.btn_prefacturar = false;
        break;
      default:
        // eliminar luego de pruebas
        // this.btn_documentada = false;
        // this.btn_prefacturar = false;
        break;
    }
  }

  // #region DOCUMENTADA

  async onDocumentada() {
    try {

      if (!this.PARA_OVDOCUMENTADA || this.PARA_OVDOCUMENTADA.length === 0) {
        const res = await this.paramRepository.getTblParametros({ para_clave: "OVDOCUMENTADA" }).toPromise();
        if (res.datos.status === 200) this.PARA_OVDOCUMENTADA = res.datos.result;
      }
      const paramOVDoc = this.PARA_OVDOCUMENTADA.find(e => e.para_clave === 'OVDOCUMENTADA');

      if (!paramOVDoc) {
        await this.util.MessageDialog({ titulo: 'INFORMACIÓN', tipo: 'warning', mensaje: 'Falta parámetro OVDOCUMENTADA.' });
        return;
      }

      this.util.MessageDialog({
        titulo: 'Confirmar', mensaje: '¿Desea Documentar la Orden de Venta?', tipo: 'warning',
        pregunta: {
          onAccept: () => {
            const callbackContinuarLogica = (dataRecibidaDelPadre: any) => {
              // Esta función se ejecutará cuando el padre nos de la data
              this.ejecutarLogicaConDatos(dataRecibidaDelPadre, paramOVDoc);
            };

            // Emitimos la función hacia el padre
            this.onDocumentadaFn.emit(callbackContinuarLogica);
          },
          onReject: () => { return; }
        },
        textoBtn: { textoBtnOpcion1: 'Sí, Confirmar', textoBtnOpcion2: 'No, Cancelar' }
      });
    } catch (ex) { console.error(ex); }
  }

  private async ejecutarLogicaConDatos(data: any, paramOVDoc: any) {
    try {
      const { request: crudItems, itemsFlete, itemsCNTR } = data;
      let hayError = false;

      const resOp = MantenimientoOVOperacionesLogica.ValidarOperaciones(crudItems, true);
      if (!resOp.isCorrect) {
        hayError = true;
        await this.util.MessageDialog({ titulo: 'VALIDACIÓN', mensaje: 'Errores:', tipo: 'warning', detalle: resOp.mensajeError });
        return;
      }

      const resCntr = MantenimientoOVOperacionesLogica.ValidarContenedores(crudItems, itemsFlete, itemsCNTR);
      if (!resCntr.isCorrect) {
        hayError = true;
        await this.util.MessageDialog({ titulo: 'ERROR CONTENEDORES', mensaje: 'Inconsistencia:', tipo: 'warning', detalle: resCntr.mensajeError });
        return;
      }

      if (!hayError) {
        if (crudItems.ccot_emitirhbl == true && crudItems.cons_codvia != "002") {
          this.util.MessageDialog({
            titulo: 'Validación HBL', mensaje: 'El RO cuenta con la opción de Emisión de HBL, ¿Desea continuar?', tipo: 'warning',
            pregunta: {
              onAccept: () => {
                this.insercionEventoDocumentacion(crudItems, paramOVDoc);
              },
              onReject: () => { return; }
            },
            textoBtn: { textoBtnOpcion1: 'Sí, Confirmar', textoBtnOpcion2: 'No, Cancelar' }
          });
        } else {
          this.insercionEventoDocumentacion(crudItems, paramOVDoc);
        }
      }

    } catch (e) { console.error("Error en lógica hijo:", e); }
  }

  insercionEventoDocumentacion(crudItems: any, paramOVDoc: ParametrosNSDTO) {
    const loadingScreen = this.util.showLoadingScreen({ message: 'Documentando...' });

    try {
      crudItems.pchrCONS_CodEST = '002';
      const constantMod = (this.ListaMods && this.ListaMods.length > 0) ? this.ListaMods[0] : null;

      const itemEventoTarea: itemsTnsEventosOvRequest = {
        CCOT_Tipo: crudItems.psinCCOT_Tipo,
        CCOT_Numero: crudItems.pintCCOT_Numero,
        EVEN_Item: 0,
        EVEN_Fecha: this.util.formatearfecha(new Date(), "yyyy-MM-ddTHH:mm:ss") || null,
        EVEN_Cumplida: true,
        EVEN_Usuario: this.oRow.usuario,
        EVEN_Observaciones: 'La Orden de Venta ha cambiado de estado a Documentada.',
        TIPO_TabEVE: 'EVE',
        TIPO_CodEVE: paramOVDoc.para_valor,
        CONS_TabMOD: constantMod ? "MOD" : null,
        CONS_CodMOD: constantMod ? constantMod.value : null,
        EVEN_Manual: false,
        AUDI_UsrCrea: this.oRow.usuario,
        ESTADO_OBJ: 'I',
        AUDI_UsrMod: this.oRow.usuario
      };

      this.ordenventaService.transaccionEventosOv({ tablaEvento: [itemEventoTarea] }).subscribe(res => {
        if (res.datos.status === 200) {
          loadingScreen.close();
          // this.util.ShowMessage({ titulo: 'ÉXITO', mensaje: 'OV Documentada.', tipo: 'ok', autocerrar: true });
          this.onDocEnd.emit();
        }
      }, err => {
        loadingScreen.close();
        const mensaje = err?.error?.meta?.mensaje || (err?.error?.errors ? Object.values(err.error.errors).flat().join(' | ') : 'Error');
        this.util.MessageDialog({ titulo: 'ERROR', mensaje: mensaje, tipo: 'warning', icono: 'pi pi-exclamation-triangle' });
      })

    } catch (err) { loadingScreen.close(); }

  }

  //#endregion

}

